// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__61Voe","show":"LoadingOverlay_show__XTCtk","text":"LoadingOverlay_text__w7fKz"};